module.exports = __webpack_public_path__ + "static/media/c6.0300d71f.jpg";